import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";

import AddFile from "../svgIcon/AddFile";
import ChangeFile from "../svgIcon/ChangeFile";
import DeleteFile from "../svgIcon/DeleteFile";
import { DeleteIcon } from "../svgIcon/DeleteIcon";
import { PlusIcon } from "../svgIcon/PlusIcon";

const UploadWrapperImage = ({ title, onChangeFile, id, name, file, alt, image, setImage }) => {
  let fileInput = React.createRef();

  const theme = useTheme();

  const [imagePreviewUrl, setImagePreviewUrl] = useState("");

  const [uploadImg, setUploadImg] = useState(false);

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    const imageFile = e.target.files[0];
    reader.onloadend = () => {
      const image = reader.result;
      setImage(image);
      setImagePreviewUrl(image);
    };
    reader.readAsDataURL(imageFile);
    onChangeFile(e);
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  const handleRemove = () => {
    setImage("");
    setImagePreviewUrl("");
    fileInput.current.value = null;
  };

  const resetFileInput = () => {
    // resetting the input value
    handleRemove();
    setUploadImg(false);
  };

  const insertImg = () => {
    setUploadImg(true);
  };

  return (
    <>
      {image === "" ? (
        <Stack
          width="100%"
          textAlign="center"
          justifyContent="center"
          alignItems="center"
          p={2}
          bgcolor="grey.gb"
          sx={{ borderRadius: 2 }}
        >
          <Typography variant="body2">{title}</Typography>
          <Stack
            spacing={1}
            p={4}
            justifyContent="center"
            alignItems="center"
            sx={{ border: "2px dashed ", m: "16px auto", borderRadius: 1, borderColor: "link.main" }}
          >
            <input
              ref={fileInput}
              hidden
              accept=".jpg,.png"
              id={id}
              name={name}
              type="file"
              onChange={handleImageChange}
            />
            <IconButton component="label" variant="text" onClick={() => fileInput.current.click()}>
              <AddFile color={theme.palette.link.main} fontSize="large" />
            </IconButton>

            <Typography variant="subtitle1" color="link.main">
              یک فایل برای آپلود انتخاب کنید.
            </Typography>
            <Typography variant="caption" color="text.caption">
              یا فایل موردنظرتان را بکشید و در این کادر رها کنید.
            </Typography>
          </Stack>

          <Typography variant="caption" color="text.caption">
            حداکثر حجم فایل:700 کیلوبایت <br />
            نوع فایل:JPG,PNG
          </Typography>
        </Stack>
      ) : (
        <Stack
          width="100%"
          textAlign="center"
          justifyContent="center"
          alignItems="center"
          p={2}
          bgcolor="grey.gb"
          sx={{ borderRadius: 2 }}
        >
          <Typography variant="subtitle2">{title}</Typography>

          <Stack
            height={200}
            p={2}
            spacing={1}
            justifyContent="center"
            alignItems="center"
            sx={{ border: "2px dashed ", m: "16px auto", borderRadius: 1, borderColor: "warning.main" }}
            position="relative"
            zIndex={1}
          >
            <input
              ref={fileInput}
              hidden
              accept=".jpg,.png"
              id={id}
              name={name}
              type="file"
              onChange={handleImageChange}
            />

            <Stack direction="row" spacing={1}>
              <IconButton
                component="label"
                variant="text"
                onClick={() => handleRemove()}
                sx={{ bgcolor: theme.palette.error.dark }}
              >
                <DeleteFile color={theme.palette.error.light} fontSize="large" />
              </IconButton>
              <IconButton
                component="label"
                variant="text"
                onClick={() => handleClick()}
                sx={{ bgcolor: theme.palette.warning.main }}
              >
                <ChangeFile color={theme.palette.warning.light} fontSize="large" />
              </IconButton>
            </Stack>

            <Typography variant="subtitle1" color="warning.main">
              یک فایل برای آپلود انتخاب شد.
            </Typography>

            <Box sx={{ borderRadius: 2, margin: 0 }} position="absolute" bottom={0} zIndex={-1}>
              {imagePreviewUrl && (
                <img
                  src={imagePreviewUrl}
                  alt={alt}
                  width={400}
                  height={196}
                  style={{ borderRadius: 16, objectFit: "cover" }}
                />
              )}
            </Box>
          </Stack>
          <Typography variant="caption" color="text.caption">
            {file?.name}
          </Typography>

          <Stack direction="row" spacing={1}>
            {uploadImg && imagePreviewUrl !== "" ? (
              <IconButton
                component="label"
                variant="text"
                onClick={() => resetFileInput()}
                sx={{ bgcolor: theme.palette.success.light }}
              >
                <DeleteIcon color={theme.palette.success.dark} fontSize="small" />
              </IconButton>
            ) : (
              <IconButton
                component="label"
                variant="text"
                onClick={() => insertImg()}
                sx={{ bgcolor: theme.palette.success.light }}
              >
                <PlusIcon color={theme.palette.success.dark} fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default UploadWrapperImage;
